import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ROUTE_TITLES: Record<string, string> = {
  "/home": "Inicio",
  "/perfil": "Perfil",
  "/estadisticas": "Estadísticas",
  "/estadisticas-admin": "Estadísticas Admin",
  "/aseos": "Aseos",
  "/clientes-propietarios": "Clientes y propietarios",
  "/clientes": "Clientes y propietarios",
  "/finanzas": "Finanzas",
  "/finanzas-cliente": "Finanzas Cliente",
  "/agenda-contactos": "Agenda de contactos",
  "/agenda-maestros": "Agenda de contactos",
  "/costos-sugeridos": "Costos sugeridos",
  "/mercado": "Mercado",
  "/mercado-cliente": "Precios y demanda",
  "/inventario": "Inventario",
  "/lavanderia": "Lavandería",
  "/historial": "Historial",
  "/finanzas-empresa": "Finanzas Empresa",
  "/propiedades": "Propiedades",
  "/tareas": "Tareas",
  "/tareas-cliente": "Tareas",
  "/calendario": "Calendario",
  "/backup": "Backup",
  "/almacenamiento": "Almacenamiento",
  "/login": "Iniciar Sesión",
};

export function useDocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const section = ROUTE_TITLES[pathname];
    document.title = section ? `${section} | Aloja Fácil` : "Aloja Fácil";
  }, [pathname]);
}
